export default __webpack_public_path__ + "static/media/chance.45ebb049.png";